export const idlFactory = ({ IDL }) => {
  const AssignmentResult = IDL.Record({
    'participantCodes' : IDL.Vec(IDL.Tuple(IDL.Text, IDL.Text)),
  });
  const AssignmentResponse = IDL.Variant({
    'Success' : IDL.Text,
    'InvalidCode' : IDL.Null,
    'AlreadyUsed' : IDL.Null,
  });
  return IDL.Service({
    'createAssignment' : IDL.Func([IDL.Vec(IDL.Text)], [AssignmentResult], []),
    'getAssignment' : IDL.Func([IDL.Text], [AssignmentResponse], []),
  });
};
export const init = ({ IDL }) => { return []; };
